'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
	processInclude(require('base/contactUs/contactUs'));
	processInclude(require('./contactUs/appointmentForm'));
});
